import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryKeys";
import { SettingsShell } from "@/components/SettingsShell";
import { MembersTable } from "@/components/MembersTable";
import { Button } from "@/components/Button";
import { Icon } from "@/components/Icon";

/**
 * /settings/members — mirrors the MEMBERS panel in designs/Settings.html:
 * .panel with a head row (title + Invite CTA) and an .mtable body.
 * The existing MembersTable component owns role-change authz and is
 * shared with /admin/users, so it stays the inner renderer; we only
 * adjust the surrounding chrome to match the design.
 */
function MembersSettings() {
  const navigate = useNavigate();
  const me = useQuery({ queryKey: queryKeys.me(), queryFn: api.me });
  const isAdmin = me.data?.user.role === "admin";
  return (
    <SettingsShell>
      <div className="panel">
        <div
          className="panel-head"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div>
            <h3>Members</h3>
            <p>Manage who can access this workspace.</p>
          </div>
          {/* Non-admins can't create invites server-side, so hide the
              affordance entirely rather than ship a button that 403s. */}
          {isAdmin && (
            <Button
              variant="primary"
              size="sm"
              style={{ marginLeft: "auto" }}
              onClick={() => navigate({ to: "/admin/invites" })}
            >
              <Icon name="plus" />
              Invite
            </Button>
          )}
        </div>
        <div className="panel-body">
          <MembersTable />
        </div>
      </div>
    </SettingsShell>
  );
}

export const Route = createFileRoute("/settings/members")({
  component: MembersSettings,
});
